import React from "react";
import { useState } from "react";
import UploadDocument from "../../../comman/UploadDocument";
import { PDFDocument } from 'pdf-lib';

const UploadLocal = (props) => {

    const { setLocalDocs } = props;

    const [updDocs, setUpdDocs] = useState([]);

    const onFileChange = async (event) => {
        const docs = [...updDocs];
        const frmData = new FormData();
        let key = 0;
        for (const file of event.target.files) {
            var doc = {
                name: file.name,
                type: file.type,
                file: file,
                size: file.size,
            };
            docs.push(doc);
            key += 1;
            frmData.append("files[" + key + "]", file);
        }
        setUpdDocs(docs);
        setLocalDocs(docs);
        // const { data: result } = await http.post(config.ScanDocumentVirus, frmData);
        // //console.log(result);
        // if (result === "NoVirus") {
        //     this.setState({ documents: docs });
        // } else {
         //    getAlert("Malware Detected", "File cannot be uploaded", "error");
        // }
    };

    const handleFileRemove = (item) => {
        const index = updDocs.indexOf(item);
        let documents = [...updDocs];
        if (index !== -1) {
            documents.splice(index, 1);
            setUpdDocs(documents);
            setLocalDocs(documents);
        }
    };

    async function compressPDF(file) {
        const arrayBuffer = await file.arrayBuffer();
        const pdfDoc = await PDFDocument.load(arrayBuffer);

        // Remove metadata
        pdfDoc.setTitle('');
        pdfDoc.setAuthor('');
        pdfDoc.setSubject('');
        pdfDoc.setKeywords([]);
        pdfDoc.setProducer('');
        pdfDoc.setCreator('');

        // Re-save the document (reduces size a bit)
        const compressedPdf = await pdfDoc.save({ useObjectStreams: true });

        return new Blob([compressedPdf], { type: 'application/pdf' });
    }

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const compressedBlob = await compressPDF(file);
        const compressedUrl = URL.createObjectURL(compressedBlob);

        console.log('Compressed size:', (compressedBlob.size / 1024 / 1024).toFixed(2), 'MB');

        // Optionally trigger a download
        const link = document.createElement('a');
        link.href = compressedUrl;
        link.download = 'compressed.pdf';
        link.click();
    };

    return <>
        {/* <h3>Compress PDF</h3>
        <input type="file" accept="application/pdf" onChange={handleFileChange} /> */}
        <UploadDocument
            documents={updDocs}
            onFileChange={onFileChange}
            handleFileRemove={handleFileRemove}
        ></UploadDocument>
    </>
}

export default UploadLocal;